












import {Component, Prop, Vue} from 'vue-property-decorator';
import TrModal from "@/components/shared/TrModal.vue";
import {btnClasses} from '@/utils/btnClasses';

@Component({
  components: {
    TrModal,
  }
})
export default class cartLimitReachedModal extends Vue {
  btnClasses = btnClasses;

  @Prop({default: false}) private showModal!: boolean;

  get sampleSelectorLink() {
    return _mgnl.siteSettings.sampleSelectorLink;
  }

  close() {
    this.$emit('close');
  }
}
